export default __webpack_public_path__ + "static/media/5.c9b05721.jpg";